import React, { useState } from 'react';
import { mdiInformationOutline } from '@mdi/js';
import { observer } from 'mobx-react';
import { Tooltip } from 'reactstrap';
import Icon from '@mdi/react';
import './StaticTooltip.scss';

export type TooltipDirections = 'top' | 'bottom' | 'left' | 'right';

interface IStaticTooltipProps {
  tooltipMessage: string;
  tooltipSide: TooltipDirections;
  id: string;
  extraClass?: string;
  icon?: string;
  title?: string;
}

export const StaticTooltip = observer((props: IStaticTooltipProps) => {
  const { tooltipMessage, tooltipSide, id, extraClass = '', icon = mdiInformationOutline, title } = props;

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <>
      <button className={`usa-button usa-button--unstyled ${extraClass}`} title={title} id={id}>
        <Icon className="information-tooltip-icon" path={icon} size={1} />
      </button>

      <Tooltip autohide={true} flip={true} placement={tooltipSide} isOpen={tooltipOpen} trigger={'hover'} target={id} toggle={toggle} aria-label="Information">
        {tooltipMessage}
      </Tooltip>
    </>
  );
});
